import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CollectionBaseManagementService {
  constructor(private http: HttpClient) {}

  loadTxtFile(formData: any): Observable<any> {
    return this.http.post(
      `${environment.API_BORYS_BACK}/baserecaudacion/servicio/cargararchivotxt`,
      formData
    );
  }

  generateTxtFile(formData: any): Observable<any> {
    return this.http.post(
      `${environment.API_BORYS_BACK}/baserecaudacion/servicio/generararchivotxt`,
      formData,
      { responseType: "blob", observe: 'response' }
    );
    // "observe" allow to fetch all response body => { body: {}, headers: {}, ...}
  }

  downloadTemplate(modalidad: string): Observable<Object> {
    let params: HttpParams = new HttpParams();
    params = params.set('modalidad', modalidad);

    return this.http.get(
      `${environment.API_BORYS_BACK}/baserecaudacion/servicio/descargarplantilla?` + params.toString(), { responseType: "blob", observe: 'response' });
  }
}
